import React, { ChangeEvent } from 'react';
import { Box, Typography, OutlinedInput } from '@mui/material';
import styles from '../styles';
import { ColorPicker } from '../../../../../../components/ColorPicker';

interface Props {
  id: number;
  content: any;
  preview: boolean;
  onChange: (id: number, value: any) => void;
}

export function RiskIndicator({ id, content, preview, onChange }: Props) {
  function handleChange(field: 'riskCount' | 'labelLow' | 'labelHigh' | 'descriptionLow' | 'descriptionHigh') {
    return (e: ChangeEvent<HTMLInputElement>) => {
      const value = field === 'riskCount' ? Number(e.target.value) : e.target.value;
      onChange(id, { ...content, [field]: value });
    };
  }

  function handleChangeColor(index: 0 | 1) {
    return (hex: string) => {
      const nextColors = Array.isArray(content?.colors) ? [...content.colors] : ['#6EA8FE', '#9EE493'];
      nextColors[index] = hex;
      onChange(id, { ...content, colors: nextColors });
    };
  }

  const startColor = content?.colors?.[0] || '#6EA8FE';
  const endColor = content?.colors?.[1] || '#9EE493';

  return (
    <Box sx={(theme) => styles.widget(theme, { preview })}>
      <Typography variant="h5" sx={{ mb: 12 }}>Risk Indicator</Typography>

      <Box sx={{ display: 'flex', gap: 16, mb: 12 }}>
        <Box sx={{ width: 160 }}>
          <Typography variant="caption" sx={{ mb: 1, display: 'block' }}>Risk count</Typography>
          <OutlinedInput type="number" value={content?.riskCount ?? ''} onChange={handleChange('riskCount')} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Typography variant="caption">Gradient</Typography>
          <ColorPicker color={startColor} onChange={handleChangeColor(0)}>
            <Box sx={{ width: 36, height: 24, borderRadius: 1, border: '1px solid #ccc', backgroundColor: startColor }} />
          </ColorPicker>
          <Typography variant="caption">→</Typography>
          <ColorPicker color={endColor} onChange={handleChangeColor(1)}>
            <Box sx={{ width: 36, height: 24, borderRadius: 1, border: '1px solid #ccc', backgroundColor: endColor }} />
          </ColorPicker>
          <Box sx={{ width: 120, height: 24, borderRadius: 1, border: '1px solid #eee', background: `linear-gradient(90deg, ${startColor}, ${endColor})` }} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 16, mb: 12 }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" sx={{ mb: 1, display: 'block' }}>Low label</Typography>
          <OutlinedInput fullWidth value={content?.labelLow || ''} onChange={handleChange('labelLow')} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" sx={{ mb: 1, display: 'block' }}>High label</Typography>
          <OutlinedInput fullWidth value={content?.labelHigh || ''} onChange={handleChange('labelHigh')} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 16 }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" sx={{ mb: 1, display: 'block' }}>Low description</Typography>
          <OutlinedInput fullWidth value={content?.descriptionLow || ''} onChange={handleChange('descriptionLow')} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" sx={{ mb: 1, display: 'block' }}>High description</Typography>
          <OutlinedInput fullWidth value={content?.descriptionHigh || ''} onChange={handleChange('descriptionHigh')} />
        </Box>
      </Box>
    </Box>
  );
}




